import React from 'react';

const STROKE_DARK = '#434E5F';

const IconWrapper = ({ state, children }) => {
  const isDone = state === 'done';
  const isIdle = state === 'idle';

  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
      <rect x="0.5" y="0.5" width="49" height="49" rx="8.5" stroke="#EBEBEB" />
      <rect x="1" y="1" width="48" height="48" rx="8" fill={isDone ? '#6E43B9' : 'white'} fillOpacity={isDone ? 1 : 0.95} />
      <g opacity={isIdle ? 0.5 : 1}>
        <g transform="translate(13 13)">
          {children(isDone ? '#FFFFFF' : STROKE_DARK)}
        </g>
      </g>
    </svg>
  );
};

export const SaveIcon = ({ state = 'idle' }) => (
  <IconWrapper state={state}>
    {(stroke) => (
      <path
        d="M10 2V5C10 5.26522 10.1054 5.51957 10.2929 5.70711C10.4804 5.89464 10.7348 6 11 6H16M18 18V12C18 11.7348 17.8946 11.4804 17.7071 11.2929C17.5196 11.1054 17.2652 11 17 11H11C10.7348 11 10.4804 11.1054 10.2929 11.2929C10.1054 11.4804 10 11.7348 10 12V18M18 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V6M8 18C7.46957 18 6.96086 17.7893 6.58579 17.4142C6.21071 17.0391 6 16.5304 6 16V4C6 3.46957 6.21071 2.96086 6.58579 2.58579C6.96086 2.21071 7.46957 2 8 2H17.172C17.7024 2.00011 18.211 2.2109 18.586 2.586L21.414 5.414C21.7891 5.78899 21.9999 6.29761 22 6.828V16C22 16.2635 21.9479 16.5244 21.8468 16.7677C21.7457 17.011 21.5975 17.2319 21.4107 17.4178C21.2239 17.6036 21.0022 17.7507 20.7584 17.8506C20.5146 17.9506 20.2535 18.0013 19.99 18H8Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </IconWrapper>
);

export const ComputeIcon = ({ state = 'idle' }) => (
  <IconWrapper state={state}>
    {(stroke) => (
      <path
        d="M8 6H16M16 14V18M16 10H16.01M12 10H12.01M8 10H8.01M12 14H12.01M8 14H8.01M12 18H12.01M8 18H8.01M6 2H18C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </IconWrapper>
);

export const FindIcon = ({ state = 'idle' }) => (
  <IconWrapper state={state}>
    {(stroke) => (
      <path
        d="M3 7V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H7M17 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V7M21 17V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H17M7 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V17M16 16.0001L14.1 14.1001M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </IconWrapper>
);

export const PrepareIcon = ({ state = 'idle' }) => (
  <IconWrapper state={state}>
    {(stroke) => (
      <path
        d="M13.9988 7L16.9988 10M4.99878 6V10M18.9988 14V18M9.99878 2V4M6.99878 8H2.99878M20.9988 16H16.99878M10.9988 3H8.99878M21.6388 3.64005L20.3588 2.36004C20.2463 2.24636 20.1124 2.15612 19.9648 2.09452C19.8171 2.03293 19.6588 2.00122 19.4988 2.00122C19.3389 2.00122 19.1805 2.03293 19.0329 2.09452C18.8853 2.15612 18.7513 2.24636 18.6388 2.36004L2.35882 18.64C2.24514 18.7526 2.15489 18.8865 2.0933 19.0341C2.03171 19.1817 2 19.3401 2 19.5C2 19.66 2.03171 19.8184 2.0933 19.966C2.15489 20.1136 2.24514 20.2475 2.35882 20.36L3.63882 21.64C3.75065 21.755 3.88436 21.8463 4.03207 21.9087C4.17978 21.971 4.33849 22.0031 4.49882 22.0031C4.65916 22.0031 4.81787 21.971 4.96558 21.9087C5.11329 21.8463 5.247 21.755 5.35882 21.64L21.6388 5.36005C21.7537 5.24822 21.8451 5.11451 21.9074 4.9668C21.9698 4.81909 22.0019 4.66038 22.0019 4.50005C22.0019 4.33971 21.9698 4.181 21.9074 4.03329C21.8451 3.88558 21.7537 3.75187 21.6388 3.64005Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </IconWrapper>
);
